var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTagline',{attrs:{"elements":_vm.tagline_elem}}),_c('BitQLoginPage',{attrs:{"service_title":_vm.service_title,"showcase_id":_vm.showcase_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }